/* eslint-disable jsx-a11y/anchor-is-valid */
import { Plus } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/src/shadComponents/ui/button';
import useJobHelpers from './hooks/useJobHelpers';

const statuses: any = {
    Ready: 'text-green-700 bg-green-50 ring-green-600/20',
    Okay: 'text-muted-foreground bg-muted/50 ring-gray-500/10',
    'Needs Artwork': 'text-red-700 bg-red-50 ring-red-600/10',
    'Needs Configuration': 'text-red-700 bg-red-50 ring-red-600/10',
};

function classNames(...classes: any[]) {
    return classes.filter(Boolean).join(' ');
}

interface ActivationsListProps {
    jobId: number;
}

export default function ActivationsList({ jobId }: ActivationsListProps) {
    const navigate = useNavigate();
    const [activations, setActivations] = useState<any[]>([]);
    const { getJobActivations } = useJobHelpers();

    useEffect(() => {
        const getData = async () => {
            const activations = await getJobActivations(jobId);
            console.log(activations);
            setActivations(activations);
        };

        getData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="">
            <tr className="text-sm leading-6 text-foreground">
                <th
                    scope="colgroup"
                    colSpan={3}
                    className="relative isolate py-2 font-semibold"
                >
                    <div className="px-4 sm:px-8 w-max relative ">
                        Activations
                    </div>
                    <div className="absolute inset-y-0 right-full -z-10 w-screen border-b border-border bg-muted/50" />
                    <div className="absolute inset-y-0 left-0 -z-10 w-screen border-b border-border bg-muted/50">
                        <Button
                            variant="ghost"
                            size="icon-sm"
                            className="absolute right-2 top-1/2 -translate-y-1/2"
                            onClick={() => navigate('activation/create')}
                        >
                            <Plus className="size-5 text-foreground" />
                        </Button>
                    </div>
                </th>
            </tr>
            <div>
                <div className="overflow-hidden border-t border-border">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                            <table className="w-full text-left">
                                <thead className="sr-only">
                                    <tr>
                                        <th>Activation Name</th>
                                        <th className="hidden sm:table-cell">
                                            Location
                                        </th>
                                        <th>More details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {activations.map((activation) => (
                                        <tr
                                            key={activation.id}
                                            className="even:bg-muted/50"
                                        >
                                            <td className="relative py-5 pr-6">
                                                <div className="flex gap-x-6">
                                                    <div className="flex-auto">
                                                        <div className="flex items-start gap-x-3">
                                                            <div className="text-sm font-medium leading-6 text-foreground">
                                                                {
                                                                    activation.name
                                                                }
                                                            </div>
                                                            {activation.status ? (
                                                                <div
                                                                    className={classNames(
                                                                        statuses[
                                                                            activation
                                                                                .status
                                                                        ],
                                                                        'rounded-md py-1 px-2 text-xs font-medium ring-1 ring-inset',
                                                                    )}
                                                                >
                                                                    {
                                                                        activation.status
                                                                    }
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                        <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                                            {activation.type}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="absolute bottom-0 right-full h-px w-screen bg-muted" />
                                                <div className="absolute bottom-0 left-0 h-px w-screen bg-muted" />
                                            </td>
                                            <td className="hidden py-5 pr-6 sm:table-cell">
                                                <div className="text-sm leading-6 text-foreground">
                                                    {activation.location}
                                                </div>
                                                <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                                    {activation.description}
                                                </div>
                                            </td>
                                            <td className="py-5 text-right">
                                                <div className="flex justify-end">
                                                    <a
                                                        href={`/activations/${activation.id}`}
                                                        className="text-sm font-medium leading-6 text-primary hover:underline"
                                                    >
                                                        View
                                                        <span className="hidden sm:inline">
                                                            {' '}
                                                            Activation &rarr;
                                                        </span>
                                                    </a>
                                                </div>
                                                {activation.staff ? (
                                                    <div className="mt-1 text-xs leading-5 text-muted-foreground">
                                                        Owner{' '}
                                                        <span className="text-foreground">
                                                            {
                                                                activation.staff.filter(
                                                                    (
                                                                        staff: any,
                                                                    ) =>
                                                                        staff.role ===
                                                                        'Production Manager',
                                                                )[0].name
                                                            }
                                                        </span>
                                                    </div>
                                                ) : null}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
